import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import adminEn from './locales/admin/en.json';
import adminTr from './locales/admin/tr.json';
import en from './locales/en.json';
import tr from './locales/tr.json';
import publicEn from './locales/public/en.json';
import publicTr from './locales/public/tr.json';

// Flatten nested JSON structure for i18next compatibility
const flattenTranslations = (obj, prefix = '') => {
  return Object.keys(obj).reduce((acc, key) => {
    const newKey = prefix ? `${prefix}.${key}` : key;
    if (typeof obj[key] === 'object' && obj[key] !== null) {
      Object.assign(acc, flattenTranslations(obj[key], newKey));
    } else {
      acc[newKey] = obj[key];
    }
    return acc;
  }, {});
};

const resources = {
  en: {
    translation: {
      ...flattenTranslations(en),
      ...flattenTranslations(adminEn),
      ...flattenTranslations(publicEn)
    }
  },
  tr: {
    translation: {
      ...flattenTranslations(tr),
      ...flattenTranslations(adminTr),
      ...flattenTranslations(publicTr)
    }
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'tr',
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
  });

// Save language preference
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
